(() => {
  let flag = 1;

  document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', init);
    window.addEventListener('mousemove', init);
    window.addEventListener('touchstart', init);
    setTimeout(function () {
      init();
    }, 1000);
  });

  function init() {
    window.globalScriptObserver.disconnect()

    if (flag) {
      flag = 0;

      window.removeEventListener('scroll', init);
      window.removeEventListener('mousemove', init);
      window.removeEventListener('touchstart', init);

      typeof asyncVendorsLoad !== 'undefined' && asyncVendorsLoad();

      lazyLoadBgImage();
      lazyLoadIframe();
      load_all_js();
    }
  }

  function lazyLoadBgImage() {
    document.querySelectorAll('[data-bgsrc]').forEach(function (elem) {
      elem.style.backgroundImage = `url(${elem.dataset.bgsrc})`;
    });
  }

  // ingarden back-button fix: only load iframes that were explicitly deferred
  // via data-src, and never re-assign an iframe to its own current src
  // (re-assigning src triggers an extra browser-history entry per iframe).
  function lazyLoadIframe() {
    document.querySelectorAll('iframe[data-src]').forEach(function (elem) {
      if (elem.dataset.src && elem.src !== elem.dataset.src) {
        elem.src = elem.dataset.src;
      }
    });
  }

  function load_all_js() {
    setTimeout(function() {
      window.dispatchEvent(new Event('mbc_load'));
    }, 100);

    const lazyScripts = document.getElementsByTagName('script');

    Array.from(lazyScripts).forEach(s => {
      if (s.type === 'lazyload.js') {
        const script = document.createElement('script');

        if (s.dataset.src) {
          script.src = s.dataset.src;
          script.async = s.async;
          script.defer = s.defer;
          document.head.appendChild(script);
        } else if (s.innerHTML) {
          script.innerHTML = s.innerHTML;
          document.body.appendChild(script);
        }

        s.remove();
      }
    })
  }
})();
